import { TApiResponse, TNotification, TPager } from "@/types";

import http from "@/http";


/**
 * The API pages notifications with a plain Spring `Pageable` and its repository
 * query carries no ordering of its own, so the sort has to be asked for here.
 * `page` is zero-based, as Spring expects.
 */
export async function getNotifications(pager?: TPager) {
    const response = await http.get<TApiResponse<TNotification[]>>("/notifications", {
        params: {
            ...pager,
            "sort": "createdAt,desc"
        }
    })
    return response.data
}

export async function getUnreadNotificationsCount() {
    const response = await http.get<TApiResponse<number>>("/notifications/unread-count")
    return response.data
}

export async function markNotificationAsRead(id: number) {
    const response = await http.patch<TApiResponse<null>>(`/notifications/${id}/read`)
    return response.data
}

export async function markAllNotificationsAsRead() {
    const response = await http.post<TApiResponse<null>>("/notifications/read-all")
    return response.data
}
